import { createContext } from 'react'

import { UserChannelMessage } from '../../utils/fixtures'
import { convertKeysToCamelCase, getUser } from '../../utils/helper'
import type { ContextType } from './types'

export const initialValues = {
  name: '',
  firstname: '',
  lastname: '',
  role: '',
  userStats: undefined,
  actions: [],
  loadingActions: true,
  loadingUserStats: true,
  errorActions: undefined,
  errorUserStats: undefined,
  refetchUserStats: () => new Promise(() => {}),
  refetchActions: () => new Promise(() => {}),
  processingId: undefined,
  isEditorModalOpen: false,
  jurnodesAllowed: false
}

export const getStoreUser = () => {
  const userData = JSON?.parse(getUser() || '{}')
  const user = convertKeysToCamelCase(userData)
  user.name = [user.firstname, user.lastname].join(' ')
  return user
}

export const defaultDraftInvoiceCallback = (data: UserChannelMessage) => {
  console.debug('Default draft invoice callback', data)
}

export const defaultActionsCallback = (data: UserChannelMessage) => {
  console.debug('Default actions callback', data)
}

export const defaultContext: ContextType = {
  user: { ...initialValues, ...getStoreUser() },
  setUser: () => {},
  isEditor: false,
  isAdmin: false,
  isCreator: false,
  isExternal: false,
  isLegalAdvisor: false,
  isEmployeeHohner: false,
  reportingEnabled: false,
  removeUser: () => {},
  processingId: initialValues.processingId,
  setProcessingId: () => {},
  actions: initialValues.actions,
  userStats: initialValues.userStats,
  loadingActions: initialValues.loadingActions,
  loadingUserStats: initialValues.loadingUserStats,
  errorActions: initialValues.errorActions,
  errorUserStats: initialValues.errorUserStats,
  refetchUserStats: () => new Promise<any>(() => {}),
  refetchActions: () => new Promise<any>(() => {}),
  isEditorModalOpen: initialValues.isEditorModalOpen,
  setIsEditorModalOpen: () => {},
  handleDraftInvoiceGenerated: defaultDraftInvoiceCallback,
  setDraftInvoiceCallback: () => {},
  handleActionsCallback: defaultActionsCallback,
  setActionsCallback: () => {}
}

export const UserContext = createContext<ContextType>(defaultContext)
